import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const Star4 = ({ text }) => (
  <StaticQuery
    query=
      {graphql`
        query {
          star: file(relativePath: { eq: "freespin/devil.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed_withWebp_noBase64
              }
            }
          }
        }
      `}
    render={data => (
      <div className="star-holder">
      {data.star.childImageSharp.fixed ?
        <Img alt={text} fixed={data.star.childImageSharp.fixed} fadeIn={false} loading='eager' />
        : <span>{ text }</span>
      }
      </div>
    )}
  />
);

Star4.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Star4;